import '../style.scss';
import { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { IEditReportState, IGeneralInformationTab } from '../models/IEditReportState';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestion } from '@fortawesome/free-solid-svg-icons';
import Popover from 'react-bootstrap/Popover';
import 'bootstrap/dist/css/bootstrap.min.css';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import QueryService from '../../../../shared/queryService';
import ConfigService from '../../../../shared/configService';
import { IRefReportTypeFeature } from '../models/IRefFeature';
import { IFeature } from '@esri/arcgis-rest-types';
import Utils from '../../../../shared/utils';
import Autocomplete from '../../../common/autocomplete/Autocomplete';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import { EditorState, ContentState, convertFromHTML, convertToRaw } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

const GeneralInformationTab = (props: { state: IEditReportState, setState: Function, validateData: Function }) => {
  const { t } = useTranslation('sectorreports');
  const MAX_LENGTH = ConfigService.getConfig().textEditorCharLength;
  
  // State
  interface ILocalState {
    reportLayerIndex: number;
    reportType: IRefReportTypeFeature[];
  }
  const [localState, setTheLocalState] = useState<ILocalState>({
    reportLayerIndex: ConfigService.getConfig().agol?.operationalLayers.reportMain.index,
    reportType: []
  });

  const reportTypeFeature = [
    { key_: '1', value: t("newReport.singleCountry") },
    { key_: '2', value: t("newReport.multiCountry") }
  ];

  const [editorWebsiteLink, setEditorWebsiteLink] = useState(
    () => EditorState.createEmpty(),
  );

  let propscontentLink: any = '';
  // Use effect
  useEffect(() => {

    //Reference table
    getRefFeatures();
    loadContentData(props.state.generalInfoTab!);

  }, [propscontentLink]);

  const loadContentData = (val: any) => {
    if (val.link_website) {
      propscontentLink = val.link_website?.toString();
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      setEditorWebsiteLink(EditorState.createWithContent(contentState));
    }
  }

  /**
   * Set local state
   * @param prop
   * @param value 
   */
  const setLocalState = (prop: string, value: any) => {
    const obj: ILocalState = { ...localState };
    (obj as any)[prop] = value;
    setTheLocalState(obj);
  }

  /**
   * Set parent state
   * @param prop
   * @param value 
   */
  const setParentState = (prop: string, value: any) => {

    if (props.state) {
      const obj: IEditReportState = { ...props.state };
      const genInfoTab: IGeneralInformationTab = { ...obj.generalInfoTab } as IGeneralInformationTab;

      (genInfoTab as any)[prop] = value;

      // Check isOK
      props.validateData(genInfoTab);

      obj.generalInfoTab = genInfoTab;

      props.setState(obj);
    }
  }

  /**
   * Set report type
   * @param type 
   */
  const setReportType = (type: string | undefined) => {
    if (type) {
      setParentState('report_type', type);
    }
  }

  /**
   * Get reference list
   */
  const getRefFeatures = async () => {
    const obj: ILocalState = { ...localState };
    obj.reportType = reportTypeFeature;
    setTheLocalState(obj);

    // Validate data
    setValidState();
  };

  /**
   * Set valid state
   */
  const setValidState = () => {
    const obj2: IEditReportState = { ...props.state };
    const subObj: IGeneralInformationTab = { ...obj2.generalInfoTab } as IGeneralInformationTab;

    if (subObj) {
      props.validateData(subObj);
    }

    obj2.generalInfoTab = subObj;
    props.setState(obj2);
  }

  /**
   * Check if a field is required
   * @param field
   */
  const isRequired = (field: string): boolean => {
    return Utils.isRequiredField(ConfigService.getConfig().agol.operationalLayers.reportMain.psRequiredFields.generalInfo, field);
  }

  const handleEditorChangeWebsiteLink = (state: any) => {
    setEditorWebsiteLink(state);
    let currentContentAsHTML = JSON.stringify(
      draftToHtml(convertToRaw(editorWebsiteLink.getCurrentContent()))
    );

    if(Utils.removeHTMLTag(currentContentAsHTML).length > MAX_LENGTH)
    {
      currentContentAsHTML = currentContentAsHTML.slice(0, MAX_LENGTH);     
    }

    setParentState('link_website', Utils.trimWhiteSpace(currentContentAsHTML));
  };

  return (
    <div className="oneTabContent metadataTab">
      <span className="bigText">{t('newReport.generalInfo.label')}</span>

      <div className="separtorDiv"></div>

      <div className="row">
        <span className="titleSpan mediumText">1. {t('newReport.generalInfo.companyName')}</span>
        <input className="mediumText big unsetMaxWidth" type="text" required={isRequired('company_name')} placeholder={t('newReport.generalInfo.companyNamePlaceholder')} value={props.state.generalInfoTab?.company_name} onChange={(e) => { setParentState('company_name', e.target.value) }} />
      </div>

      <div className="row">
        <span className="titleSpan mediumText">2. {t('newReport.generalInfo.reportType')}</span>
        <div className="col-3 singleDDLDivType">
          {/* <select className="mediumText" disabled
              value={props.state.generalInfoTab?.ps_report_type}
              onChange={(e) => {setParentState('ps_report_type', e.target.value)}}>
              {<option value="-999" key="">{t('newReport.generalInfo.selectOnePlacehodler')}</option>}
              {localState.reportType.map((i) => <option value={i.key_} key={i.key_}>{i.value}</option>)}
            </select> */}
          <input className="mediumText big unsetMaxWidth" type="text" value={props.state.generalInfoTab?.ps_report_type === '2' ? 'Multi-country report' : 'Single country report'} />
        </div>
      </div>

      <div className="row">
        <span className="titleSpan mediumText">3. {t('newReport.generalInfo.countryHQ')}</span>
        <input className="mediumText big unsetMaxWidth" type="text" required={isRequired('country_headquarter')} placeholder={t('newReport.generalInfo.countryHQPlaceholder')} value={props.state.generalInfoTab?.country_headquarter} onChange={(e) => { setParentState('country_headquarter', e.target.value) }} />
      </div>

      <div className="row">
        <span className="titleSpan mediumText">4. {t('newReport.generalInfo.companyfocalpoint')}</span>
        <input className="mediumText big unsetMaxWidth" type="text" required={isRequired('focal_point_name')} placeholder={t('newReport.generalInfo.companyfocalpointPlaceholder')} value={props.state.generalInfoTab?.focal_point_name} onChange={(e) => { setParentState('focal_point_name', e.target.value) }} />
      </div>

      <div className="row">
        <span className="titleSpan mediumText">5. {t('newReport.generalInfo.companyfocalpointPosition')}</span>
        <input className="mediumText big unsetMaxWidth" type="text" required={isRequired('company_focal_point_position')} placeholder={t('newReport.generalInfo.companyfocalpointPositionPlaceholder')} value={props.state.generalInfoTab?.company_focal_point_position} onChange={(e) => { setParentState('company_focal_point_position', e.target.value) }} />
      </div>

      <div className="row">
        <span className="titleSpan mediumText">6. {t('newReport.generalInfo.emailAddress')}</span>
        <input className="mediumText big unsetMaxWidth" type="text" required={isRequired('email')} placeholder={t('newReport.generalInfo.emailAddressPlaceholder')} value={props.state.generalInfoTab?.email} onChange={(e) => { setParentState('email', e.target.value) }} />
      </div>
      <div className="row">
        <span className="titleSpan mediumText">7. {t('newReport.generalInfo.linkWebsite')}</span>
      </div>
      <div className="alEditorDiv">
        <Editor
          editorState={editorWebsiteLink}
          onEditorStateChange={handleEditorChangeWebsiteLink}
          wrapperClassName="wrapper-class"
          editorClassName="editor-class"
          toolbarClassName="toolbar-class"
          toolbar={{
            options: ['link'],
            link: { inDropdown: true },
          }}
        />
      </div>

    </div>
  );
};

export default GeneralInformationTab;

